var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.errorBoxClasses()},[_c('h3',[_vm._v("Oh-oh")]),_c('p',[_vm._v(_vm._s(this.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }